<ep-auth-container
  [imageSrc]="
    subdomainType === SubdomainTypes.EagleProcessing
      ? '../../../assets/eagle-logo.png'
      : '../../../assets/enroll-and-pay-logo.png'
  "
  [class.terms-and-conditions-container]="shouldShowTermsAndConditions"
>
  <div class="mb-4">
    <div *ngIf="(showTermsAndConditions$ | async) === true; else showLoginTitle">
      <h5 class="fw-semibold">Please accept our terms and conditions</h5>
    </div>
    <ng-template #showLoginTitle>
      <div>
        <h5 class="fw-semibold">Login with your merchant account</h5>
      </div>
    </ng-template>
  </div>

  <form
    *ngIf="(showTermsAndConditions$ | async) === false; else showTCForm"
    [formGroup]="fgLogin"
    (keyup.enter)="onLoginClicked()"
  >
    <div class="form-group mb-4">
      <div class="flex flex-column gap-2">
        <label class="fw-semibold" htmlFor="username">Email:</label>
        <input
          type="email"
          pInputText
          formControlName="username"
          autocomplete="email"
          [class.is-invalid]="
            fgLogin.get('username')?.invalid && (fgLogin.get('username')?.dirty || fgLogin.get('username')?.touched)
          "
          data-cy="merchant-login-email"
        />
        <div class="invalid-feedback" *ngIf="fgLogin.get('username')?.errors?.['required']">Email is required</div>
        <div class="invalid-feedback" *ngIf="fgLogin.get('username')?.errors?.['email']">Email is invalid</div>
      </div>
    </div>
    <div class="form-group mb-4">
      <div class="flex flex-column gap-2">
        <label class="fw-semibold" htmlFor="password">Password:</label>
        <p-password
          formControlName="password"
          [toggleMask]="true"
          [feedback]="false"
          autocomplete="current-password"
          [class.is-invalid]="
            fgLogin.get('password')?.invalid && (fgLogin.get('password')?.dirty || fgLogin.get('password')?.touched)
          "
          data-cy="merchant-login-password"
        ></p-password>
        <div class="invalid-feedback" *ngIf="fgLogin.get('password')?.errors?.['required']">Password is required</div>
      </div>
    </div>
    <div class="mb-4">
      <p-button
        label="LOGIN"
        [loading]="isLoading"
        (onClick)="onLoginClicked()"
        data-cy="merchant-login-button"
      ></p-button>
    </div>
    <div>
      Forgot Password? x
      <a (click)="onForgotPasswordClicked()" routerLinkActive="active">Click here to reset</a>
    </div>
  </form>

  <ng-template #showTCForm>
    <app-terms-and-conditions [isLoading]="isLoading" (accept)="onLoginWithTcClicked()" />
  </ng-template>
</ep-auth-container>
